import { colorsTuple, createTheme } from '@mantine/core';

export const THEME_COLORS = {
  background: {
    primary: '#0F0F0F',
    secondary: '#1a1a1a',
    tertiary: '#2d2d2d',
    quaternary: '#3d3d3d'
  },
  accent: {
    primary: '#FF5D02',
    blue: '#3b82f6',
    orange: '#FF5D02',
    secondary: '#eaeaea',
    hover: '#FF8A3D',
    active: '#E65300',
    tint: 'rgba(255, 93, 2, 0.05)',
    tintHover: 'rgba(255, 93, 2, 0.08)',
    borderTint: 'rgba(255, 93, 2, 0.3)',
    borderTintHover: 'rgba(255, 93, 2, 0.6)'
  },
  text: {
    primary: '#ffffff',
    secondary: '#999999',
    dimmed: '#666666'
  },
  border: {
    primary: '#333333',
    secondary: '#444444',
    modal: '#1E1E28',
    hairline: 'rgba(255, 255, 255, 0.08)',
    hairlineHover: 'rgba(255, 255, 255, 0.15)',
    divider: 'rgba(255, 255, 255, 0.06)'
  },
  surface: {
    card: 'rgba(255, 255, 255, 0.02)',
    neutralFill: 'rgba(255, 255, 255, 0.04)'
  }
};

export const ThemeConstants = createTheme({
  colors: {
    primary: colorsTuple('#FF5D02')
  },
  defaultRadius: 3,
  fontFamily: 'Karla, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
  fontSizes: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '20px',
    xl: '24px'
  },
  headings: {
    fontWeight: '700',
    sizes: {
      h1: { fontSize: '48px', lineHeight: '1.2' },
      h2: { fontSize: '40px', lineHeight: '1.2' },
      h3: { fontSize: '32px', lineHeight: '1.3' },
      h4: { fontSize: '24px', lineHeight: '1.4' },
      h5: { fontSize: '20px', lineHeight: '1.4' },
      h6: { fontSize: '16px', lineHeight: '1.5' }
    }
  },
  components: {
    Container: {
      defaultProps: {
        size: 1400
      }
    },
    Anchor: {
      defaultProps: {
        td: 'none'
      }
    },
    Title: {
      defaultProps: {
        c: 'bright'
      }
    },
    Button: {
      defaultProps: {
        color: 'var(--mantine-color-primary-5)',
        c: '#000'
      }
    },
    NumberFormatter: {
      defaultProps: {
        thousandSeparator: ',',
        decimalSeparator: '.',
        decimalScale: 2,
        prefix: '$'
      }
    },
    Modal: {
      defaultProps: {
        centered: true
      },
      styles: {
        header: {
          padding: '0 1rem'
        },
        content: {
          background: THEME_COLORS.background.primary,
          border: `1px solid ${THEME_COLORS.border.modal}`
        }
      }
    }
  }
});
